module.exports = __webpack_public_path__ + "img/penn-engineering.903e77a6.jpg";